// extracted by mini-css-extract-plugin
export default {"rootContainer":"src-pages-SalesChannelCategory-Components-RootWrapper-css-module__rootContainer--q+x4C"};